import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    Chip,
} from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { formatDate, parseDate, StatusRenderer } from "./user_list_columnDefs";

const dateCol = (headerName, field, extra = {}) => ({
    headerName,
    colId: field,
    width: 165,
    valueGetter: (p) => parseDate(p.data?.[field]),
    valueFormatter: (p) => formatDate(p.value),
    ...extra,
});

const orderColumns = [
    { headerName: "Order ID", field: "order_id", width: 270 },
    { headerName: "Plan", field: "subscription_name", width: 330 },
    dateCol("Ordered on", "subscribed_on", { sort: "desc" }),
    dateCol("Started on", "subscription_started_on"),
    dateCol("Expires on", "expiry_date"),
    {
        headerName: "Order status",
        field: "order_status",
        width: 140,
        cellRenderer: StatusRenderer,
    },
    {
        headerName: "Subscription status",
        field: "subscription_status",
        width: 170,
        cellRenderer: StatusRenderer,
    },
    { headerName: "Lapsed", field: "lapsed", width: 220 },
    { headerName: "Age", field: "subscription_age", width: 260 },
];

const defaultColDef = { sortable: true, resizable: true, filter: true };

const orderGridSx = {
    height: 420,
    width: "100%",
    "& .ag-cell": {
        overflow: "hidden !important",
        display: "flex !important",
        alignItems: "center",
    },
    "& .ag-cell-wrapper, & .ag-cell-value": {
        width: "100%",
        minWidth: 0,
        overflow: "hidden !important",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
};

export default function UserOrdersDialog({ user, onClose }) {
    const orders = user?.order_records ?? [];
    const consumed = user?.consumed_orders ?? [];

    return (
        <Dialog open={Boolean(user)} onClose={onClose} fullWidth maxWidth="xl">
            <DialogTitle>
                {user?.name}
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {user?.email} - {orders.length}{" "}
                    {orders.length === 1 ? "order" : "orders"}
                </Typography>
            </DialogTitle>

            <DialogContent dividers>
                <Box
                    className="ag-theme-alpine-dark user-admin-grid"
                    sx={orderGridSx}
                >
                    <AgGridReact
                        rowData={orders}
                        columnDefs={orderColumns}
                        defaultColDef={defaultColDef}
                        rowHeight={46}
                        headerHeight={44}
                        enableCellTextSelection
                    />
                </Box>

                {consumed.length > 0 && (
                    <Box sx={{ mt: 2.5 }}>
                        <Typography
                            variant="body2"
                            sx={{ color: "text.secondary", mb: 1 }}
                        >
                            Consumed plans
                        </Typography>
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                            {consumed.map((name, i) => (
                                <Chip
                                    key={`${name}-${i}`}
                                    label={name}
                                    size="small"
                                    variant="outlined"
                                />
                            ))}
                        </Box>
                    </Box>
                )}
            </DialogContent>

            <DialogActions>
                <Button
                    variant="contained"
                    onClick={onClose}
                    sx={{ textTransform: "none", color: "#ffffff" }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
